import { MemdbBoolean, TournamentType } from "@ssf/memdb-api";
import { tournamentsByDateQuery } from "@ssf/memdb-components";
import { useQuery } from "@tanstack/react-query";

export const useY2cTournaments = () => {
  const { data: tournaments = [], ...query } = useQuery(
    tournamentsByDateQuery(TournamentType.Yes2Chess),
  );

  const isRegOpen = tournaments.some(({ classes }) =>
    classes.some(({ groups }) =>
      groups.some(({ status }) => status === MemdbBoolean.True),
    ),
  );

  return { ...query, tournaments, isRegOpen };
};
